import * as Sentry from "@sentry/react";
import { classifyNetworkError } from "./sentryUtils";

let reported = false;

/**
 * Reports a failed recording-lease request to Sentry, at most once per recording session: a lease that keeps
 * failing renews every minute, and one event says the lease is not being set. Offline and network failures
 * are expected while recording on a poor connection and are not reported. Never throws.
 */
export function reportRecordingLeaseFailure(error: unknown, action: "renew" | "release") {
    try {
        const errorCategory = classifyNetworkError(error);
        if (reported || errorCategory === "connectivity") return;
        reported = true;
        const status = (error as { response?: { status?: unknown } } | null)?.response?.status;
        Sentry.captureException(error, {
            tags: { errorType: "recording_lease", errorCategory },
            extra: { action, status },
        });
    } catch {
        // best-effort
    }
}

/** A new recording session may report again. */
export function resetRecordingLeaseFailureReport() {
    reported = false;
}
